import { render, staticRenderFns } from "./LinhaDeDadosResumo.vue?vue&type=template&id=1c9cdadc&scoped=true"
import script from "./LinhaDeDadosResumo.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeDadosResumo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeDadosResumo.vue?vue&type=style&index=0&id=1c9cdadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9cdadc",
  null
  
)

export default component.exports